import { Box, Typography, Paper, useTheme, useMediaQuery, IconButton, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import { tokens } from "../theme";
import { useTranslation } from 'react-i18next';

const StatBox = ({ title, value, unit, icon, subtitle, iconColor, infoContent }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [infoAnchor, setInfoAnchor] = useState(null);

  const { t } = useTranslation();
  return (
    <Paper
      elevation={2}
      sx={{
        p: isMobile ? 1.5 : 3,
        backgroundColor: colors.grey[800],
        borderRadius: "8px",
        height: "100%",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box display="flex" alignItems="center" gap={0.25}>
            <Typography variant={isMobile ? "caption" : "body2"} color={colors.grey[300]} fontWeight="500" sx={{ fontSize: isMobile ? '0.7rem' : undefined }}>
              {t(title)}
            </Typography>
            {infoContent && (
              <>
                <IconButton size="small" onClick={(e) => setInfoAnchor(e.currentTarget)} sx={{ color: colors.grey[500], p: 0, mb: 0.75 }}>
                  <InfoOutlinedIcon sx={{ fontSize: 11 }} />
                </IconButton>
                <Popover
                  open={Boolean(infoAnchor)}
                  anchorEl={infoAnchor}
                  onClose={() => setInfoAnchor(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <Box sx={{ p: 2, maxWidth: 300 }}>
                    {infoContent}
                  </Box>
                </Popover>
              </>
            )}
          </Box>
          <Box display="flex" alignItems="baseline" mt={isMobile ? 0.5 : 1}>
            <Typography variant={isMobile ? "h5" : "h3"} fontWeight="bold" color={colors.grey[100]} sx={{ fontSize: isMobile ? '1rem' : undefined, wordBreak: 'break-word' }}>
              {value}
            </Typography>
            {unit && (
              <Typography variant={isMobile ? "body2" : "h5"} color={colors.grey[400]} ml={1}>
                {unit ? t(unit) : ''}
              </Typography>
            )}
          </Box>
          {subtitle && (
            <Typography variant="body2" color={colors.grey[400]} mt={1}>
              {subtitle ? t(subtitle) : ''}
            </Typography>
          )}
        </Box>
        {icon &&  (
          <Box
            sx={{
              fontSize: "40px",
              color: iconColor || colors.blueAccent[500],
              opacity: 0.7,
              ml: 2
            }}
          >
            {icon}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default StatBox;
